import React, { useState } from 'react';
import './ProblemSection.css';
import close from '../../../assets/multiply-circle.svg';
import videoThumb from '../../../assets/video_problem.svg';

const problems = [
    'Misallocation of Resources',
    'Inefficient Operations',
    'Unrealistic Goals and Targets',
    'Poor Investor Confidence',
];

const ProblemSection = () => {
    const [isPlaying, setIsPlaying] = useState(false);

    return (
        <section className="problem-section">
            <div className="problem-container page-container">
                <div className="problem-container-1">
                    <div className="problem-grid-one">
                        <h3>The Problem</h3>
                        <p>What does a world without access to data look like?</p>
                    </div>
                    <ul className="problem-grid-two">
                        {problems.map((item) => (
                            <li key={item}>
                                <img src={close} alt="" aria-hidden="true" />
                                <span>{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="problem-container-2">
                    <div className="video-responsive">
                        {isPlaying ? (
                            <iframe
                                src="https://www.youtube.com/embed/fDBGZCQCXpY?autoplay=1&si=A2BBtoJsF9YsUDec"
                                title="Sonaroid Analytics - Data and Insights for Africa"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        ) : (
                            <button
                                type="button"
                                className="video-thumbnail"
                                onClick={() => setIsPlaying(true)}
                                aria-label="Play video"
                            >
                                <img src={videoThumb} alt="Sonaroid Analytics video thumbnail" />
                            </button>
                        )}
                    </div>

                    <div className="problem-grid-four">
                        <div className="problem-stat-body">
                            <h1>
                                75<span>%</span>
                            </h1>
                            <p>of the world&apos;s population without access to energy live in Africa</p>
                        </div>
                        <div className="source-info">
                            <span className="horizontal-line" />
                            <p>Source of Information</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProblemSection;
